import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import InsCommentDetailsPage from "@saleor/inscomment/components/InsCommentDetailsPage";
import {
  useCreateComment,
  useUpdateCommentVisible
} from "@saleor/inscomment/mutations";
import { useInsCommentDetailsQuery } from "@saleor/inscomment/queries";
import { commentListUrl } from "@saleor/inscomment/urls";
import { commonMessages } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";

interface InsCommentDetailsProps {
  id: string;
  // params:InsCommentPathUrlQueryParams;
}
export const InsCommentDetails: React.FC<InsCommentDetailsProps> = ({ id }) => {
  const { data, loading, refetch } = useInsCommentDetailsQuery({
    variables: { id }
  });
  const intl = useIntl();
  const notify = useNotifier();
  const [updateVisible] = useUpdateCommentVisible({
    onCompleted: data => {
      if (data.updateCommentVisible.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage(commonMessages.savedChanges)
        });
        refetch();
      }
    }
  });
  const [addComment] = useCreateComment({
    onCompleted: data => {
      if (data.createComment.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage(commonMessages.savedChanges)
        });
        refetch();
      }
    }
  });
  const navigate = useNavigator();
  return (
    <>
      <InsCommentDetailsPage
        insComment={data?.commentById}
        disabled={loading}
        btnComment={data =>
          addComment({
            variables: {
              parentId: id,
              parentType: "Comment",
              text: data.message
            }
          })
        }
        btnIsVisible={() =>
          updateVisible({
            variables: {
              id
            }
          })
        }
        onBack={() => navigate(commentListUrl())}
      />
    </>
  );
};
export default InsCommentDetails;
